// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tlm-counter .v-btn-toggle>.v-btn.v-btn{border-bottom:none;border-top:none}.tlm-counter .v-btn-toggle>.v-btn.v-btn:first-child{border-left:none}.tlm-counter .v-btn-toggle>.v-btn.v-btn:last-child{border-right:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
